module.exports = __webpack_public_path__ + "static/justinb-765b4e9ce7ad8648d970c0de8d585124.jpg";